import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Checkout = lazy(() => import("@/pages/Checkout"));

export const Route = createFileRoute("/kassa")({
  validateSearch: (search: Record<string, unknown>) => ({
    plan: typeof search["plan"] === "string" ? (search["plan"] as string) : undefined,
    omr: typeof search["omr"] === "string" ? (search["omr"] as string) : undefined,
    bolag: typeof search["bolag"] === "string" ? (search["bolag"] as string) : undefined,
    // Avtal från Avtals-API-feeden – utan detta tappas kortet i kassan.
    avtal: typeof search["avtal"] === "string" ? (search["avtal"] as string) : undefined,
    consumption:
      search["consumption"] != null && !Number.isNaN(Number(search["consumption"]))
        ? Number(search["consumption"])
        : undefined,
    gast: search["gast"] === "1" ? "1" : undefined,
  }),
  head: () => seoHead("/kassa"),
  component: CheckoutRoute,
});

function CheckoutRoute() {
  const search = Route.useSearch();
  return <Checkout search={search} />;
}
